export interface IBudgetThresholdData {
  id: number;
  number: number;
  name: string;
  budget: number;
  totalCosts: number;
  percent: number;
  threshold: number;
}

export function isBudgetThresholdData(data: unknown): data is IBudgetThresholdData {
  if (data == null || typeof data !== 'object') {
    return false;
  }

  const candidate = data as Partial<IBudgetThresholdData>;
  return (
    typeof candidate.id === 'number' &&
    typeof candidate.number === 'number' &&
    typeof candidate.name === 'string' &&
    typeof candidate.budget === 'number' &&
    typeof candidate.totalCosts === 'number' &&
    typeof candidate.percent === 'number' &&
    typeof candidate.threshold === 'number'
  );
}
